export const RESOURCES = {
    premises: { administrate: "nenda-only", visibleFromBelow: false },
    units: { administrate: "nenda-only", visibleFromBelow: false },
    screens: { administrate: "nenda-and-partners", visibleFromBelow: false },
    "screens/messages": { administrate: "not-used", visibleFromBelow: false },
    "screens/alerts": { administrate: "nenda-only", visibleFromBelow: false },
    "software-updates": { administrate: "nenda-only", visibleFromBelow: false },
    signage: { administrate: "nenda-only", visibleFromBelow: true },
    "signage/slide-content": { administrate: "not-used", visibleFromBelow: true },
    "signage-templates": { administrate: "nenda-only", visibleFromBelow: true },
    media: { administrate: "nenda-only", visibleFromBelow: true },
    "tv-layout": { administrate: "nenda-only", visibleFromBelow: false },
    "tv-layout/translations": {
        administrate: "nenda-only",
        visibleFromBelow: false,
    },
    "guest-web": { administrate: "nenda-only", visibleFromBelow: false },
    offers: { administrate: "nenda-only", visibleFromBelow: true },
    "guest-requests": { administrate: "nenda-only", visibleFromBelow: false },
    "pms-link": { administrate: "nenda-only", visibleFromBelow: false },
    statistics: { administrate: "not-used", visibleFromBelow: false },
    residents: { administrate: "not-used", visibleFromBelow: false },
    "residents/care-requests": {
        administrate: "not-used",
        visibleFromBelow: false,
    },
    "residents/photos": { administrate: "not-used", visibleFromBelow: false },
    "patient-data": {
        administrate: "not-used",
        visibleFromBelow: false,
        personalOnly: true,
    },
    "audit-log": { administrate: "not-used", visibleFromBelow: false },
    "video-calls": { administrate: "nenda-only", visibleFromBelow: false },
    licences: { administrate: "nenda-only", visibleFromBelow: false },
    "licences/metered-usage": {
        administrate: "nenda-only",
        visibleFromBelow: false,
    },
    companies: { administrate: "nenda-only", visibleFromBelow: false },
    users: { administrate: "nenda-only", visibleFromBelow: false },
    distribution: { administrate: "not-used", visibleFromBelow: false },
    "distribution/titles": {
        administrate: "nenda-only",
        visibleFromBelow: false,
    },
    "distribution/channels": {
        administrate: "nenda-only",
        visibleFromBelow: false,
    },
    "distribution/packages": {
        administrate: "nenda-only",
        visibleFromBelow: false,
    },
    "distribution/rails": { administrate: "nenda-only", visibleFromBelow: false },
    "distribution/suppliers": {
        administrate: "nenda-only",
        visibleFromBelow: false,
    },
    "supplier-trust": { administrate: "nenda-only", visibleFromBelow: false },
    "content-owners": { administrate: "nenda-only", visibleFromBelow: false },
    "content-owners/brand": { administrate: "not-used", visibleFromBelow: false },
    storefront: { administrate: "nenda-only", visibleFromBelow: false },
    "global-settings": { administrate: "nenda-only", visibleFromBelow: false },
    "client-errors": { administrate: "nenda-only", visibleFromBelow: false },
    demos: { administrate: "nenda-only", visibleFromBelow: false },
    "sales-videos": { administrate: "nenda-only", visibleFromBelow: false },
};
export const RESOURCE_PATHS = Object.keys(RESOURCES);
export function isResourcePath(value) {
    return (typeof value === "string" &&
        Object.prototype.hasOwnProperty.call(RESOURCES, value));
}
export function areaOf(path) {
    const slash = path.indexOf("/");
    return slash < 0 ? null : path.slice(0, slash);
}
export function lookupOrder(path) {
    const area = areaOf(path);
    return area ? [path, area] : [path];
}
